export const COLUMNS = [
    {
        Header: "Descrição",
        accessor: "nome",
    }
]


